import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  loadTouristRoutesItem,
  saveTouristRoutesItem,
  saveTouristRoutesItemAsDraft,
} from 'store/slices/touristRoutes/actions';
import {
  ITouristRoutesDraftItem,
  ITouristRoutesItem,
} from 'store/slices/touristRoutes/interfaces';
import { LangEnum } from 'constants/lang';

import { TouristRoutesForm } from './components/TouristRoutesForm';
import { mapValuesToForm } from './components/formUtils';

export const AddTranslation = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.touristRoutes);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadTouristRoutesItem(id));
  }, []);

  const onFinish = (values: ITouristRoutesItem) => {
    setIsLoading(true);
    dispatch(saveTouristRoutesItem(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/touristRoutes');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: ITouristRoutesDraftItem) => {
    setIsLoading(true);
    dispatch(saveTouristRoutesItemAsDraft(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/touristRoutes');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/touristRoutes');
  };

  // catalog values depends on lang
  const preparedValues = {
    ...item,
    lang: LangEnum.en,
    tags: [],
    tagsData: null,
    routeType: null,
    routeTypeData: null,
    routeLevel: null,
    routeLevelData: null,
  };

  return (
    <MainLayout pageTitle='Создание'>
      {item.id && item.id === Number(id) ? (
        <TouristRoutesForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft
          isLoading={isLoading}
          initialValues={mapValuesToForm(preparedValues)}
        />
      ) : null}
    </MainLayout>
  );
};
